import { addStyles } from 'ethcss'
import { color, IStyles } from 'theme'

const contextMenuStyles: IStyles = {
    menu: {
        position: 'fixed',
        zIndex: 10001,
        minWidth: 180,
        padding: '4px 0',
        background: color.bgWhitePrimary,
        border: `1px solid ${color.borderDarkTertiary}`,
        borderRadius: 8,
        boxShadow: `0 8px 24px ${color.bgAlphaDark50}`,
    },
    item: {
        display: 'block',
        width: '100%',
        textAlign: 'left',
        padding: '8px 14px',
        border: 0,
        background: 'transparent',
        color: color.fontDarkUltraHigh,
        cursor: 'pointer',
        fontSize: 13,

        '&:hover:not(:disabled)': {
            background: color.bgWhiteSecondary,
        },

        '&:disabled': {
            opacity: 0.4,
            cursor: 'default',
        },
    },
    itemDanger: {
        color: color.critical,

        '&:hover:not(:disabled)': {
            background: color.critical100,
            color: color.critical,
        },
    },
    separator: {
        height: 1,
        margin: '4px 0',
        background: color.borderDarkPrimary,
    },
    empty: {
        padding: '8px 14px',
        color: color.fontDarkLow,
        fontSize: 13,
    },
}

addStyles(contextMenuStyles)
export default contextMenuStyles
